// extracted by mini-css-extract-plugin
export default {"root":"BarChartSkeleton_root__49nMJ"};